/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ControllerPlayPauseEvent extends alm.event.Event {

		public static CHANGE:string = 'ControllerPlayPauseEvent.CHANGE';





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, isPlayingRequired:boolean) {
			super(eventType, target);
			this.isPlayingRequired = isPlayingRequired;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsPlayingRequired():boolean {
			return this.isPlayingRequired;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isPlayingRequired:boolean;
	}
}
